import { View } from 'react-native'
import Animated, {
  interpolate,
  interpolateColor,
  useAnimatedStyle,
} from 'react-native-reanimated'
import useAnimatedToggle from '@ui/hooks/useAnimatedToggle'
import { AnimatedPressable } from '@ui/animated/nativewindReanimated'
import { DealType } from '@ca/common/types'
import { colors } from '@ui/colors'
import Logo from '@shell/Logo'
import cn from '@ui/utils/cn'

import { useBrandFilter } from '@order/hooks/useBrandFilter'
import { getClassName } from '@ui/buttons/ButtonsFixed/ButtonsGrid'

interface Props {
  brandId: DealType
  index: number
  total: number
}

export default function Brand({ brandId, index, total }: Props) {
  const { activeBrandOption, setBrand } = useBrandFilter()

  const isActive = activeBrandOption?.id === brandId
  const animation = useAnimatedToggle(!!isActive)

  const styleActive = useAnimatedStyle(() => ({
    opacity: interpolate(animation.value, [0, 1], [0.2, 1]),
    backgroundColor: interpolateColor(
      animation.value,
      [0, 1],
      [colors.black, colors.magenta[800]]
    ),
  }))

  const logoKey = brandId !== 'normal' ? brandId : 'normal'

  const isMultiple = total > 1

  return (
    <>
      {isMultiple && index > 0 && <Separator />}
      <AnimatedPressable
        className={cn('flex h-full items-center justify-center')}
        onPress={!isActive ? () => setBrand(brandId) : undefined}
        style={{
          position: 'relative',
          top: isMultiple ? -8 : 0,
          flex: 1,
        }}
      >
        <View className={getClassName(total, index)}>
          <Logo color={colors.black} variant={logoKey} />
          {isMultiple && (
            <Animated.View
              className={cn(
                'absolute rounded-full',
                getClassName(total, index)
              )}
              style={[{ width: 24, height: 6, bottom: -16 }, styleActive]}
            />
          )}
        </View>
      </AnimatedPressable>
    </>
  )
}

const Separator = () => (
  <View className="h-16 bg-black/10" style={{ width: 1 }} />
)
